<template>
  <div id="app">
    <!-- <keep-alive :include="cachedViews"> -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import { setFavicon } from "@/utils/common";
export default {
  name: 'App',
  data() {
    return {
      // network: true, //默认有网
    }
  },
  components: {
    
  },
  computed: {
    // cachedViews() {
    //   return this.$store.state.user.cachedViews
    // }
  },
  methods: {
    
  },
  // mounted() {
  //   // 检测断网
  //   window.addEventListener('offline', () => {
  //     this.network = false
  //     this.$message({
  //         message: '当前网络不佳,请检查网络信息',
  //         type: "warning",
  //     });
  //   })
  //   window.addEventListener('online', () => {
  //     this.network = true
  //   })
  // },
  // destroyed() {
  //   window.removeEventListener("offline", () => {});
  //   window.removeEventListener("online", () => {});
  // }
  mounted() {
    const url =
      "https://file.gkzzd.cn/www/gkzzd/uploads/20250321/34176b7dce083448e164ba03183db7aa.ico";
     setFavicon(url);
     document.title = "高考早知道-升学、实习、就业一站式成才服务平台";
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  background-color: #FFFFFF;
  /* margin-top: 60px; */
}
</style>
